import React, { useContext, useEffect, useState } from "react";
import {
  Circle,
} from "@react-google-maps/api";
import MapDownloadDataModal from "../mapDownloadDataModal/MapDownloadDataModal";
import { DownloadModalTypes } from "../../../../../constants/WebMap";
import { WebMapContext } from "../../../../../pages/sections/web-map/WebMapGoogleMap";
import { isNumber } from "@turf/turf";
import {
  CircleToolControls,
  LeftCircle,
  RangeContainer,
  RangeInput,
  RangeMarkers,
  RangeWrapper,
  SelectButton,
  SelectButtonContainer,
  Title,
  ValueDisplay,
} from "./DownloadPinTool.styled";

const DownloadPinTool = ({ toolMarkers }) => {
  const {
    downloadProperties, setDownloadProperties,
  } = useContext(WebMapContext);
  const minRadius = 1;
  const [maxRadius, setMaxRadius] = useState(5);
  const valuePercent =
    ((downloadProperties?.radius - minRadius) / (maxRadius - minRadius)) * 100;
  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRadiusChange = (event) => {
    const newRadius = parseFloat(event.target.value);
  
    if (!isNaN(newRadius)) {
      setDownloadProperties({...downloadProperties, radius: parseFloat(newRadius )});
    }
  };

  useEffect(() => {
    if (isNumber(downloadProperties?.maximumRadiusDownloadPin)) {
      setMaxRadius(downloadProperties.maximumRadiusDownloadPin);
    }
  }, [downloadProperties?.maximumRadiusDownloadPin]);

  return (
    <>
      {toolMarkers[0] && (
        <Circle
          center={toolMarkers[0]}
          radius={downloadProperties?.radius * 1000}
          options={{
            strokeColor: "#016F35",
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: "#016F352F",
            fillOpacity: 0.9,
            zIndex: 1,
          }}
        />
      )}
      <CircleToolControls>
        <Title>Select Radius</Title>
        <RangeWrapper>
          <RangeContainer>
            <RangeMarkers>
              <span>{downloadProperties?.maximumRadiusDownloadPin} KM</span>
            </RangeMarkers>
            <LeftCircle />
            <RangeInput
              type="range"
              min={minRadius}
              max={maxRadius}
              step={0.1}
              value={downloadProperties?.radius}
              onChange={handleRadiusChange}
              valuePercent={valuePercent}
            />
            <ValueDisplay>
              {parseFloat(downloadProperties?.radius)?.toFixed(2)} KM
            </ValueDisplay>
          </RangeContainer>
          <SelectButtonContainer>
            <SelectButton
              onClick={() => {
                setDownloadProperties({
                  ...downloadProperties,
                  coordinates: [toolMarkers[0]],
                });
                setIsModalOpen(true);
              }}
            >
              Select
            </SelectButton>
          </SelectButtonContainer>
        </RangeWrapper>
      </CircleToolControls>
      {isModalOpen ? (
        <MapDownloadDataModal
          data={{ maxRadius: maxRadius }}
          type={DownloadModalTypes.PIN}
          isOpen
          onClose={() => setIsModalOpen(false)}
        />
      ) : null}
    </>
  );
};

export default DownloadPinTool;
